import apiClient from '@/services/axios'

const augustusClient = {
  get: (url, config) => apiClient.get(`/augustus-proxy${url}`, config),
  post: (url, data, config) => apiClient.post(`/augustus-proxy${url}`, data, config),
}

export default augustusClient
